import httpClient from "../http/http-client";
import { downloadBlob } from "../../utils/download-file-utils";

export default class UploadedResourceService {
  http;

  constructor() {
    this.http = httpClient;
  }

  async getDownloadBlob(uploadedResourceId: string): Promise<Blob> {
    return this.http.get(`uploaded-resource/${uploadedResourceId}`, { responseType: 'blob' })
      .then((response: any) => response.data)
      .catch((err: any) => {
        console.log(err);
        throw err;
      });
  }

  async downloadFile(uploadedResourceId: string, suggestedFilename?: string): Promise<void> {
    if (!uploadedResourceId) return;
    const blob = await this.getDownloadBlob(uploadedResourceId);
    downloadBlob({ blob, fileName: suggestedFilename || 'download' });
  }
}


